import React, { Component } from 'react';
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Lib from '../../../commons/lib';
import BizonylattipusLista from './BizonylattipusLista';
import BizonylattombLista from './BizonylattombLista';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '././Bizonylattooltips';

class Bizonylatkezeles extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: undefined,
    };
  }

  componentDidMount() {
    this.initTab();
  }

  initTab = () => {
    let activeTab = '1';
    if (this.props.globals.hasRole(['BIZONYLAT_TOMB'])) activeTab = '2';
    if (this.props.globals.hasRole(['BIZONYLAT_TIPUS'])) activeTab = '1';

    this.setState({ activeTab: activeTab });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  render() {
    let cardStyle = {
      padding: 20
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              Bizonylatkezelés
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {
                    this.props.globals.hasRole(['BIZONYLAT_TIPUS']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => { this.toggle('1'); }}
                      >
                        Bizonylattípus
                        <CustomTooltip text={getTooltip('bizonylattipus')} id="bizonylattipusTT" />
                      </NavLink>
                    </NavItem>
                    )}
                  {
                    this.props.globals.hasRole(['BIZONYLAT_TOMB']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '2' })}
                        onClick={() => { this.toggle('2'); }}
                      >
                        Bizonylattömb
                        <CustomTooltip text={getTooltip('bizonylattomb')} id="bizonylattombTT" />
                      </NavLink>
                    </NavItem>
                    )}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  {
                    this.props.globals.hasRole(['BIZONYLAT_TIPUS']) && (
                    <TabPane tabId="1">
                      <BizonylattipusLista
                        {...this.props}
                        globals={this.props.globals}
                        ref={(instance) => { this.child1 = instance; }}
                        active={this.state.activeTab === '1'}
                      />
                    </TabPane>
                    )}
                  {
                    this.props.globals.hasRole(['BIZONYLAT_TOMB']) && (
                    <TabPane tabId="2">
                      <BizonylattombLista
                        {...this.props}
                        globals={this.props.globals}
                        ref={(instance) => { this.child2 = instance; }}
                        active={this.state.activeTab === '2'}
                      />
                    </TabPane>
                    )}
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Bizonylatkezeles.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default Bizonylatkezeles;
